/*  React  */
import { Typography } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import React from 'react';

import { Percentage } from '../Text';

/**
 * A React component that renders a percentage value in a table cell.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.column - The column object.
 * @param {Object} props.column.columnDef - The column definition object.
 * @param {string} props.column.columnDef.accessorKey - The key to access the value in the row object.
 * @param {string} [props.column.columnDef.defaultKey] - The translation key for the default value.
 * @param {Object} props.cell - The cell object containing the data.
 *
 * @returns {React.ReactElement} The rendered table cell component.
 */
export const PercentageCell = <TData,>({
    cell
}: CellContext<TData, unknown>): React.ReactElement => {
    const value = (cell.getValue() || 0) as number;

    return (
        <Typography>
            <Percentage percent={value} />
        </Typography>
    );
};
